module.exports = __webpack_public_path__ + "media/honey-icons/receiver_dual-4f7e69fd.svg";